import { getSupplierContactsSearchText } from '../../utils/supplierContacts';
import type { SupplierContact } from '../../utils/supplierContacts';

type SearchableSupplier = {
  name?: string | null;
  address?: string | null;
  taxId?: string | null;
  contactPerson?: string | null;
  contactPeople?: SupplierContact[] | null;
  phone?: string | null;
  email?: string | null;
};

const normalizeSearchValue = (value?: string | null) => (value || '').trim().toLowerCase();
const compactSearchValue = (value?: string | null) => normalizeSearchValue(value).replace(/[^a-z0-9]+/g, '');

const buildSearchFragments = (value?: string | null) => {
  const normalized = normalizeSearchValue(value);

  if (!normalized) {
    return [];
  }

  const compact = normalized.replace(/[^a-z0-9]+/g, '');
  const withoutCountryPrefix = compact.replace(/^[a-z]{2}/, '');

  return Array.from(new Set([normalized, compact, withoutCountryPrefix].filter(Boolean)));
};

export function buildSupplierSearchText(supplier: SearchableSupplier) {
  return [
    ...buildSearchFragments(supplier.name),
    ...buildSearchFragments(supplier.taxId),
    ...buildSearchFragments(supplier.address),
    ...buildSearchFragments(
      getSupplierContactsSearchText(
        supplier.contactPeople,
        supplier.contactPerson,
        supplier.phone,
        supplier.email
      )
    ),
  ].join(' ');
}

export function matchesSupplierSearch(supplier: SearchableSupplier, query: string) {
  const normalizedQuery = normalizeSearchValue(query);
  const compactQuery = compactSearchValue(query);

  if (!normalizedQuery) {
    return true;
  }

  const searchText = buildSupplierSearchText(supplier);
  return searchText.includes(normalizedQuery) || Boolean(compactQuery && searchText.includes(compactQuery));
}
